module.exports = __webpack_public_path__ + "img/logo.03b77f56.svg";